export default __webpack_public_path__ + "static/media/DP.044e2ada.png";